<template>
  <div class="popup">
    <div class="box full-page">
      <header class="d-flex justify-content-between">
        <div class="content">
          <h2>{{ $t("Gestion des photos") }}</h2>
        </div>
        <div class="button">
          <label for="newPictures" class="cta">{{ $t("Importer") }}</label>
          <input ref="myFiles" type="file" class="hide" id="newPictures" @change="uploadImages" multiple />
        </div>
      </header>
      <div class="img-list">
        <ul>
          <draggable v-model="images.ordered" @start="drag = true" @end="drag = false">
            <li class="el" v-for="(img, index) in images.ordered" :key="index">
              <button class="delete-image-library" @click="deleteImage(img)">
                <svg enable-background="new 0 0 212.982 212.982" viewBox="0 0 212.982 212.982" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m131.8 106.49 75.936-75.936c6.99-6.99 6.99-18.323 0-25.312-6.99-6.99-18.322-6.99-25.312 0l-75.937 75.937-75.937-75.938c-6.99-6.99-18.322-6.99-25.312 0-6.989 6.99-6.989 18.323 0 25.312l75.937 75.936-75.937 75.937c-6.989 6.99-6.989 18.323 0 25.312 6.99 6.99 18.322 6.99 25.312 0l75.937-75.937 75.937 75.937c6.989 6.99 18.322 6.99 25.312 0s6.99-18.322 0-25.312z" fill-rule="evenodd"/></svg>
              </button>
              <button class="file-picker">
                <img :src="img" :alt="img" />
              </button>
            </li>
          </draggable>
          <li class="el" v-for="i in imagesLoading" :key="'loading-'+i"><div class="loader"></div></li>
          <li class="el" v-for="i in errors" :key="'error-'+i">Error</li>
        </ul>
        <div class="no-image-library" v-if="images.ordered.length < 1">
          <strong>{{ $t("Pas d'image") }}</strong>
        </div>
      </div>
      <div class="actions">
        <button class="cta" @click="sendToProperty">Enregistrer</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";
import modalBus from "@/bus/modal-bus";

export default {
  props:["data"],
  components: {
    draggable,
  },
  data:function() {
    return {
      images: {
        ordered: [],
        add: [],
        delete: [],
        current: [],
      },
      imagesLoading:0,
      errors:0
    };
  },
  methods: {
    uploadImages() {
      const formData = new FormData(),
        numberOfFiles = this.$refs.myFiles.files.length;

      for (let i = 0; i < numberOfFiles; ++i) {
        this.imagesLoading++;
        formData.append("images[" + i + "]", this.$refs.myFiles.files[i]);
      }
      this.$axios
        .post("/app/library/create", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          response.data.forEach((el) => {
            this.imagesLoading--;
            el = this._global.rServer +"s"+ el;
            this.images.add.push(el);
            this.images.ordered.push(el);
          });
        })
        .catch((e) => {
          this.imagesLoading--;
          this.errors++;
        });
    },
    deleteImage(imgToRemove) {
      let isTemp = this.images.add.findIndex((el) => imgToRemove === el);
      // is temp so provided by add
      isTemp !== -1 ? this.images.add.splice(isTemp, 1) : this.images.delete.push(imgToRemove);

      let imgIndex = this.images.ordered.findIndex((el) => imgToRemove === el);
      this.images.ordered.splice(imgIndex, 1);
    },
    sendToProperty() {
      modalBus.sendAndClose({
        emit: {
          name: "library-save-images",
          data: this.images,
        },
      });
    },
  },
  mounted() {
    this.images = this.data;
  },
};
</script>
